// providerLabel — operator-facing display string for a rail's provider.
//
// NO VENDOR OR BANK NAME APPEARS HERE, AND NONE MAY BE ADDED.
//
// This function used to return "IDFC Bank" and "Buckzy", and unmapped
// providers fell through to the raw key — so "razorpayx_inr" and the wire
// token "razorpayx" rendered as-is. Every one of those is a vendor name in
// text a human reads, on fourteen call sites: payout detail, the rails
// tables, routing rules, limits, the beneficiary modal, toasts.
//
// The names below describe what a rail IS to an operator — where it sends
// money and how it is driven — which is the part they actually need, and is
// stable if the counterparty behind it ever changes.
//
// A / B distinguish the two domestic API rails. They are deliberately opaque:
// there is no non-vendor way to tell them apart, operators identify a rail by
// its own label ("29V2155SVGITOGND"), and the provider is the secondary
// qualifier next to it. If you want different wording, this file is the only
// place to change it.
//
// Both spellings are mapped for every rail: the internal routing key
// (paysmart_idfc) and the neutralised wire token the backend's publicProvider()
// emits (idfc). Missing the second is how a vendor name gets back on screen.
const LABELS: Record<string, string> = {
  // Domestic INR, API-driven.
  paysmart_idfc: "Domestic rail A",
  idfc: "Domestic rail A",
  razorpayx_inr: "Domestic rail B",
  razorpayx: "Domestic rail B",
  touras_inr: "Domestic rail C",
  touras: "Domestic rail C",

  // Cross-border.
  buckzy_global_payout: "Cross-border rail",
  buckzy: "Cross-border rail",

  // No API: an operator exports a file and uploads it at the bank.
  // "manual" carries an admin-defined column grid; the fixed-format rail's
  // layout is published by the bank it belongs to.
  manual: "Manual file rail",
  canara_bank: "Bank file rail",
};

export function providerLabel(provider: string): string {
  const known = LABELS[provider];
  if (known) return known;
  // Unknown provider. Do NOT fall back to the raw key — that is exactly how
  // "razorpayx_inr" reached the screen. A new rail this file has not been
  // taught is described generically until somebody adds it above.
  return "Payout rail";
}
